import { IMessageDisplayText, ListItem, Pill } from '@localina/core';
import { ChevronRightIcon } from '@localina/icons';
import React from 'react';
import { useTranslation } from 'react-i18next';
import { LanguageCode } from '../LanguageCode';

interface IProps {
    displayText: IMessageDisplayText;

    hasLink?: boolean;
    onClick: (displayText: IMessageDisplayText) => void;
}

export const MessageDisplayTextListItem: React.FC<IProps> = (props) => {
    const { t } = useTranslation();

    const isLinkNameMissing = Boolean(props.hasLink) && !props.displayText.link;

    const handleClick = () => {
        props.onClick(props.displayText);
    };

    return (
        <ListItem
            classNames="message-language"
            title={t(`core:languages.${props.displayText.language.toLowerCase()}`)}
            subtitle={props.displayText.text}
            leftIcon={<LanguageCode language={props.displayText.language} />}
            rightIcon={
                <>
                    <Pill
                        tone={isLinkNameMissing ? 'warn' : 'good'}
                        label={t(`message.status.${isLinkNameMissing ? 'linkNameMissing' : 'complete'}`)}
                    />
                    <ChevronRightIcon />
                </>
            }
            onClick={handleClick}
        />
    );
};
